import EstimateGateway from "@/usecases/accounting/estimate-gateway";
import ClientLike from "../client-like";
import Estimate from "@/usecases/accounting/estimate";
import SaveEstimateRequest from "@/usecases/accounting/save-estimate-request";
import statusTranslater from "@/usecases/accounting/estimate-status-translater";

export default class EstimateApi implements EstimateGateway {
  public constructor(private client: ClientLike) {}

  public async find(id: number): Promise<Estimate | undefined> {
    const res = await this.client.get("get_estimate.php", {
      id,
      action: "show"
    });
    if (res.estimates.length > 0) {
      return toEstimate(res.estimates[0]);
    }
  }

  public async findAll(
    options: { projectId?: string; projectName?: string } = {}
  ): Promise<Estimate[]> {
    const res = await this.client.get("get_estimate.php", options);
    return res.estimates.map(toEstimate);
  }

  public async save(estimate: SaveEstimateRequest): Promise<number> {
    const data = await this.client.post("save_estimate.php", estimate);
    return data.id;
  }

  public async create(projectId?: string): Promise<number> {
    return await this.save(new Estimate(projectId));
  }

  public async destroy(id: number): Promise<void> {
    const d = new FormData();
    d.append("id", String(id));
    await this.client.post("delete_estimate.php", d);
  }
}

function toEstimate(estimate: any): Estimate {
  return {
    ...estimate,
    statusName: statusTranslater.toJp(estimate.status)
  };
}
